const LocationList = (state =[], action) => {
    switch(action.type){
        case 'LOCATION_LIST':
            return action.payload
    }
    return state;
}

export default LocationList;


// WEBPACK FOOTER //
// ./src/reducers/LocationList.js